import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { Category } from '../types/category.type';
import { ADMIN_CATEGORIES_API_PATHS } from '../constants/categories-api-paths.constants';

type UseRestoreCategoryResult = {
  restoreCategory: (categoryId: string) => Promise<Category | null>;
  isSubmitting: boolean;
};

export function useRestoreCategory(): UseRestoreCategoryResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const restoreCategory = async (categoryId: string): Promise<Category | null> => {
    setIsSubmitting(true);

    try {
      const restoredCategory = await HttpClient.post<Category>(ADMIN_CATEGORIES_API_PATHS.RESTORE_CATEGORY(categoryId));

      enqueueSnackbar('Rubrique restaurée', { variant: 'success' });
      return restoredCategory;
    } catch (error) {
      enqueueSnackbar(
        extractTranslatedApiErrorMessage(error, 'Une erreur est survenue lors de la restauration de la rubrique'),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { restoreCategory, isSubmitting };
}
